import { makeResource, mapped } from '@codium/codium-vue'
import { storeModule as features } from './media-owners/features'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('mediaOwners', {
  storeModule: {
    modules: {
      features
    },
  },
  resource () {
    return {
      id: mapped(null),
      name: mapped(null),
      tags: mapped([]),
      ftp_connection: {
        ftp_host: mapped(null),
        ftp_username: mapped(null),
        ftp_password: mapped(null),
        ftp_mode: mapped(null),
        enabled: mapped(true)
      },
      disabled_features: mapped([]),
    }
  }
})
